import { render } from "./VerCotizacion.vue?vue&type=template&id=7229f1fa&scoped=true"
import script from "./VerCotizacion.vue?vue&type=script&lang=js"
export * from "./VerCotizacion.vue?vue&type=script&lang=js"

import "./VerCotizacion.vue?vue&type=style&index=0&id=7229f1fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7229f1fa"]])

export default __exports__